export default __webpack_public_path__ + "static/media/SK루키.8cafe66b.svg";